import { useEffect, useRef } from 'react';
import { useUserState } from '../context/UserContext/UserContext';

const GenesysWrapper = ({ children }) => {
  const userState = useUserState();
  const didSendRef = useRef(false);

  useEffect(() => {
    if (!window.Genesys) {
      console.error('Genesys is not available');
      return;
    }

    const sendAttributes = () => {
      if (!userState?.amisId) {
        console.warn('Skipping Genesys Database.set: missing amisId');
        return;
      }

      const payload = {
        messaging: {
          customAttributes: {
            ID: String(userState.amisId),
            Name: `${userState.firstName ?? ''} ${userState.lastName ?? ''}`.trim(),
            Phone: userState.phoneNumber ?? '',
            sentAt: new Date().toISOString(),
          },
        },
      };

      try {
        window.Genesys(
          'command',
          'Database.set',
          payload,
          () => {
            didSendRef.current = true;
          },
          (error) => {
            didSendRef.current = false;
            console.error('Genesys Database.set failed', error);
          },
        );
      } catch (err) {
        didSendRef.current = false;
        console.error('Genesys Database.set threw exception', err);
      }
    };

    const onDatabaseReady = () => {
      sendAttributes();
    };

    const onMessengerOpened = () => {
      if (!didSendRef.current) {
        sendAttributes();
      }
    };

    window.Genesys('subscribe', 'Database.ready', onDatabaseReady);
    window.Genesys('subscribe', 'Messenger.opened', onMessengerOpened);

    return () => {
      window.Genesys('unsubscribe', 'Database.ready', onDatabaseReady);
      window.Genesys('unsubscribe', 'Messenger.opened', onMessengerOpened);
    };
  }, [
    userState?.amisId,
    userState?.firstName,
    userState?.lastName,
    userState?.phoneNumber,
  ]);

  return children;
};

export default GenesysWrapper;
